<template>
  <div>
    <div class="body bodylogin">
      <div class="login_center">
        <!-- Formulaire de connexion -->
        <form class="form-horizontal" v-on:submit.prevent="setPass" method="post" >
          <div class="login_table">
            <div class="login-logo">
              <img src="/img/logo-white.png" alt="Ideal Solutions" />
            </div>
            <br />
            <div class="login-fields">
              <div id="login-status">
              </div>
              <label style="color:white;">Saisir mot de passe :</label>
              <div class="input-group" style="align-items: center;">
                <!-- Ajout d'un champ pour le login -->
                <el-input id="pwd" placeholder="Mot de passe" v-model="post.pwd" required show-password style="flex: 1 0 85%;"></el-input>
                <el-popover
                  placement="top-start"
                  width="400"
                  trigger="hover"
                  content="La longueur du mot de passe doit être de 12 caractères">
                  <span slot="reference" class="input-group-addon" style="color: white; background-color: #40585F;"><i class="fas fa-info-circle"></i></span>
                </el-popover>                
              </div>
              <br/>
              <label style="color:white;">Resaisir mot de passe :</label>
              <div class="input-group">
                <el-input id="pwd2" placeholder="Mot de passe" v-model="post.pwd2" required show-password style="width: 90%;"></el-input>
              </div>
              <!-- Button Connection -->
              <br />
              <input type="submit" class="btn btn-primary btn-block" value="Créer mot de passe" tabindex="5" />
            </div>
          </div> <!-- end login table -->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import script from '../script/script.js';

export default {
  data() {
    return {
      post: {}
    }
  },
  mounted:function(){
    this.verifyToken();
  },
  created:function(){
    
  },
  methods: {
    setPass: script.setPass,
    verifyToken: script.verifyToken
  }
}
</script>

<style>

</style>
